import { render, staticRenderFns } from "./emailConfig.vue?vue&type=template&id=382f8438&scoped=true&"
import script from "./emailConfig.vue?vue&type=script&lang=js&"
export * from "./emailConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f8438",
  null
  
)

export default component.exports